import React from "react";

import {CircularProgress, Stack, Typography, Box, Chip} from "@mui/joy";

// components
import BaseApi from "../../../utils/BaseApi";
import CallCard from "../../Communication/CallCard";
import UserSubscriberContext from "../../../context/UserSubscriberContext";

// icons
import PhoneIcon from '@mui/icons-material/Phone';


class CallsTab extends React.Component {
    static contextType = UserSubscriberContext;

    constructor(props) {
        super(props);
        this.state = {
            calls: null,
            loading: true,
        };
    }

    async componentDidMount() {
        await this.retrieveCalls();
    }

    async retrieveCalls() {
        this.setState({loading: true});
        const url = `sunsim_call/`;
        const api = new BaseApi();
        const params = {
            opportunity: this.props.opportunity.id,
            ordering: '-date_time',
        };
        
        try {
            let response = await api.get(url, params);
            this.setState({
                calls: response.data.results,
                loading: false,
            });
        } catch (error) {
            console.error('Ошибка загрузки звонков:', error);
            this.setState({loading: false});
        }
    }

    render() {
        if (this.state.loading || !this.state.calls) {
            return <CircularProgress/>;
        }

        return (
            <Stack spacing={2}>
                <Box sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                }}>
                    <Typography level="title-lg">
                        Звонки по сделке
                    </Typography>
                </Box>

                {this.state.calls.length === 0 ? (
                    <Box sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        py: 5,
                        bgcolor: 'background.level1',
                        borderRadius: 1,
                    }}>
                        <PhoneIcon sx={{fontSize: 64, color: 'neutral.plainColor', mb: 2}}/>
                        <Typography level="body-lg" color="neutral">
                            Нет звонков
                        </Typography>
                        <Typography level="body-sm" color="neutral">
                            Звонки будут отображаться здесь
                        </Typography>
                    </Box>
                ) : (
                    <Stack spacing={1.5}>
                        {this.state.calls.map((call) => (
                            <CallCard
                                key={call.id}
                                call={call}
                                showPhone={true}
                                showCommunications={true}
                            />
                        ))}
                    </Stack>
                )}
            </Stack>
        );
    }
}

export default CallsTab;
